import client from '@js/client'
import publicClient from '@js/public-client'
import resources from '@js/resources'
import { camelKeyToSnakeKey, camelKeyToSnakeKeyRecursive, snakeKeyToCamelKey, } from '@js/str-utils'

const editableProperties = {
  firstName: '',
  lastName: '',
  email: '',
  image: '',
  languageCode: '',
  timezoneCode: '',
  disablePromotion: false,
}

const getDefaultState = () => {
  return {
    initialized: false,
    id: null,
    ...editableProperties,
  };
};

const user = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getUserId: state => state.id,
    getImageUrl: state => {
      if (state.image && state.image.length > 0) {
        return state.image;
      }
      return state.initialized ? require('@img/user.svg') : "//:0";
    },
  },
  mutations: {
    setUser (state, payload) {
      const properties = ['id', ...Object.keys(editableProperties)];
      properties.forEach(function (prop) {
        if (prop in payload && prop in state) {
          state[prop] = payload[prop];
        }
      });
    },
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    initialized (state) {
      state.initialized = true;
    },
    clearUser (state) {
      state.initialized = false;
      state.id = null;
      for (const key in editableProperties) {
        state[key] = editableProperties[key];
      }
    },
  },
};

export default user;
